module.exports = __webpack_public_path__ + "media/images/recruit/top/mv_logo-768ac6c1c4a30e0f78a98d0319c460ec.png";